import { render, staticRenderFns } from "./SocialMediaAccountsView.vue?vue&type=template&id=38943fd8&"
import script from "./SocialMediaAccountsView.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaAccountsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports